import { endpoint } from "@services/api.services";
import { TableCard } from "@ui/internal/components/card";
import { usePathname } from "@utils/hook/index.hook";
import { QueryData } from "@utils/interface/index.interface";
import { useListData } from "@utils/query/index.query";
import { CricketUserExportCSV } from "@services/CricketUser";
import { useMutation } from "@tanstack/react-query";
import { showToast } from "@utils/helper/index.helper";
import { Download } from "lucide-react";
import React from "react";
import { Button } from "@components/ui/button";
import { useSearchParams } from "react-router";
import { ColumnList } from "./column/index.column";
import { useMetaStore } from "@utils/states/index.state";
type Props = {};
const index: React.FC<Props> = ({}) => {
  const [searchParams] = useSearchParams();
  const pathname = usePathname();

  const columns = ColumnList();
  const { search, date } = useMetaStore();
  /* ================================================= api calls logic ================================================= */
  const { data, refetch, isPending } = useListData<QueryData<any>>({
    params: {
      page: searchParams.get("tpage") || 1,
      size: searchParams.get("per") || 10,
      ordering: searchParams.get("ordering") || "order",
      search: search,
    },
    endpoint: endpoint["cricket-userdetails"],
    key: `${pathname}-listing`,
    window: true,
  });

  const { mutate: exportCsv, isPending: isExporting } = useMutation({
    mutationFn: (size?: number) => {
      const params: any = { search };
      if (size) params.size = size;
      return CricketUserExportCSV(params);
    },
    onSuccess: (res) => {
      const url = window.URL.createObjectURL(new Blob([res.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "cricket-users.csv");
      document.body.appendChild(link);
      link.click();
      link.remove();
      showToast({
        title: "Success",
        description: "CSV exported successfully",
        type: "success",
      });
    },
    onError: () => {
      showToast({
        title: "Error",
        description: "Failed to export CSV",
        type: "error",
      });
    },
  });

  return (
    <>
      <TableCard
        bulkActions
        table_content={{
          mode: "default",
          type: "user-details",
        }}
        inject_ui_table_actions={
          <div className="flex gap-2">
            <Button
              className="bg-[#1DA077] hover:bg-[#1DA077]/90 flex gap-2"
              onClick={() => exportCsv(undefined)}
              disabled={isExporting}
            >
              <Download size={16} />
              {isExporting ? "Exporting..." : "Export .csv"}
            </Button>
          </div>
        }
        orientationPosition={false}
        endpoint={endpoint["cricket-userdetails"]}
        refetch={refetch}
        isPending={isPending}
        columns={columns}
        sortableFilter={{
          search: search,
        }}
        rows={data?.data?.results ?? []}
        count={data?.data?.count ?? 10}
        form={<></>}
      />
    </>
  );
};

export default index;
